import { IconButton, Td, Tr } from "@chakra-ui/react";
import { Usuario } from "../../utils/interfaces";
import { BiPencil } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

export function Item({usuario}: {usuario: Usuario}){
  const navigate = useNavigate();
  const statusCode = Number(usuario.status);
  const statusLabel =
    statusCode === 1 ? "Ativo" : statusCode === 0 ? "Bloqueado" : String(usuario.status);
  const goToEdit = () => navigate(`/usuario/${usuario.id}`);

  return (
    <Tr onClick={goToEdit} cursor={'pointer'} _hover={{ bg: 'yellow.500'}} p={0} className="group" key={`${usuario.id}-lista-relatorio`}>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>
        {usuario.id}
      </Td>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{usuario.nome}</Td>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{usuario.perfil}</Td>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{statusLabel}</Td>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{usuario.empresa}</Td>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{usuario.email}</Td>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>
        <IconButton icon={<BiPencil />} aria-label="editar" variant={'unstyled'}/>
      </Td>
    </Tr>
  )
}
